import { getAuthenticatedRequest } from "@/services/requestBuilder.js";
import { API_REQUESTS } from "@/constant/apiRequests.js";
import { PERMISSIONS } from "@/constant/permissions.js";

export function createGetAdminProfilesRequest() {
  return getAuthenticatedRequest(API_REQUESTS.PRIVATE.GET_ADMIN_PROFILES, {
    profile: {
      permissions: [PERMISSIONS.CHATS_ACCESS],
    },
  });
}
